/**
 * Periodic GET /api/session/keepalive (disabled by default).
 * Set REACT_APP_SESSION_KEEPALIVE_ENABLED=true in .env and rebuild to re-enable.
 */
export const SESSION_KEEPALIVE_ENABLED =
  String(process.env.REACT_APP_SESSION_KEEPALIVE_ENABLED || "false").toLowerCase() ===
  "true";
